import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, RequestMethod } from '@angular/http';
import 'rxjs/add/operator/map';

import { Cookie } from 'ng2-cookies';
import { JwtService } from '../../jwt/jwt.service';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { HttpInterceptor } from '../interceptor/http-interceptor';
import { UserService } from './user.service';
import { ImageModel } from '../model/image.model';


@Injectable()
export class ImageHostingService {

    constructor(private http: Http, private jwtService: JwtService, private userService: UserService
      , private router: Router, private customHttp: HttpInterceptor) {}

    /**
     * 이미지 목록
     * @param row
     * @param page
     */
    getImages(row: number, page: number, sort: string, title: string) {

      return this.customHttp.get(environment.imageUrl + '/images?size=' + row  + '&page=' + page + '&sort=' + sort + '&title=' + title)
      .map(response => response.json());
    }

    /**
     * 이미지 삭제
     */
    removeImages(imageId: string) {

      return this.customHttp.delete(environment.imageUrl + '/images/' + imageId);
    }

    /**
     * 이미지 업로드 (list)
     */
    uploadImages(files: File[]) {
      const formData = new FormData();
      for (const file of files) {
        formData.append('files', file);
      }

      return this.customHttp.post(environment.imageUrl + '/images', formData);
    }

    /**
     * 이미지 업로드
     */
    uploadImage(files: File) {
      const formData = new FormData();
      formData.append('files', files);
      return this.customHttp.post(environment.imageUrl + '/images', formData);
    }

    /**
     * 이미지 업로드
     */
    uploadImageFormData(formData: FormData) {
      this.customHttp.post(environment.imageUrl + '/images', formData).subscribe(response => {
        const storedImages = response.json();
        let count = 0;
        const convertCheckInterval = setInterval(() => {
        if (storedImages.length > 0) {
          this.checkConvertImage(storedImages, 'crop', 'thumbnail').subscribe(res => {
          if (res.status === 200) {
            const ret = res.json();
            if (count > 20) {
              alert('응답시간이 초과되었습니다.');
              clearInterval(convertCheckInterval);
            }

            if (ret) {
              $('#imageFile').val('');
              alert('이미지가 업로드 되었습니다.');
              clearInterval(convertCheckInterval);

              this.router.navigate(['/image/list']);
            }
            count++;
          }
        });
        } else {
          clearInterval(convertCheckInterval);
        }
      }, 2000);
      });
    }

    /**
     * 이미지 변환 체크
     */
    checkConvertImage(images: ImageModel[], convertType: String, convertName: String) {

      let url = environment.imageUrl + '/images/convertImage/' + convertType + '/' + convertName + '?';

      for (const image of images) {
         url += 'ids=' + image.imageId + '&';
      }

      return this.customHttp.get(url);
    }

    /**
     * 이미지 정보 수정
     */
    updateImage(imageId, title, description) {

      return this.customHttp.put(environment.imageUrl + '/images/' + imageId, {'title' : title, 'description' : description});
    }

    /**
     * 프로필 이미지 생성
     */
    makeProfileImage(file) {

      const formData = new FormData();
      formData.append('file', file);

      return this.customHttp.post(environment.imageUrl + '/images/extra/profile', formData);
    }


     /**
     * 포스터 목록
     * @param row
     * @param page
     */
    getPosters(row: number, page: number, sort: string, convertName: string) {

      return this.customHttp.get(environment.imageUrl + '/images?convertType=extra&convertName='
       + convertName + '&size=' + row  + '&page=' + page + '&sort=' + sort)
      .map(response => response.json());
    }




}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/common/api/image-hosting.service.ts